<template>
  <div id="app">
    <router-view />
    <van-tabbar v-model="active" @change="changeMethod(active)">
      <van-tabbar-item to="/">
        <span>首页</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons[0].img : icons[1].img"
        />
      </van-tabbar-item>
      <van-tabbar-item to="/usercenter">
        <span>我的</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons[2].img : icons[3].img"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      active: 0,
      icons: [
        { img: require('./assets/icon/appstore-active.png') },
        { img: require('./assets/icon/appstore.png') },
        { img: require('./assets/icon/person-active.png') },
        { img: require('./assets/icon/person.png') },
      ],
    }
  },
  methods: {
    changeMethod(e) {
      // console.log(e)
    },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  text-align: center;
  color: #e8e8e8;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.flex-xb {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.flex-yc {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flex-xc-yc {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue